module.exports = __webpack_public_path__ + "img/20190606110854728.d5a20345.png";